import { BadgeLogoSizeType } from '../../../../../components/badgeLogo/types/badgeLogoSizeType';
import { getEmptyStyles } from './variantStyles/empty';
import { getRegularStyles } from './variantStyles/regular';
export const getBadgeLogoStyles = (FOUNDATIONS, FONT) => {
    return {
        [BadgeLogoSizeType.MEDIUM]: {
            container: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
            },
            decorativeElement: {
                ICON: {
                    width: FOUNDATIONS.size_300,
                    height: FOUNDATIONS.size_300,
                },
                ILLUSTRATION: {
                    width: FOUNDATIONS.size_300,
                    height: FOUNDATIONS.size_300,
                },
            },
        },
        [BadgeLogoSizeType.SMALL]: {
            container: {
                width: FOUNDATIONS.size_250,
                height: FOUNDATIONS.size_250,
            },
            decorativeElement: {
                ICON: {
                    width: FOUNDATIONS.size_250,
                    height: FOUNDATIONS.size_250,
                },
                ILLUSTRATION: {
                    width: FOUNDATIONS.size_250,
                    height: FOUNDATIONS.size_250,
                },
            },
        },
        ...getRegularStyles(FOUNDATIONS, FONT),
        ...getEmptyStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map